import { isiOSApp, isAndroidApp } from "../BridgeFunction.js";
import { getAdminTokenApi, reUrl } from "Constant/apiConstant";
import { eventName } from "./GaConstant.js";
import googleAnalyticsData from "./GoogleAnalytics.js";
import { tourCustomerRoute } from "./RouteConstant/tourCustomer.js";
import axios from "axios";
import { useEffect, useState } from "react";

const assetPath = process.env.REACT_APP_AZUR_ASSET_PATH;

export const convertPrice = (price) => {
  return Number(parseFloat(price).toFixed(2)).toLocaleString("en", {
    minimumFractionDigits: 2,
  });
};
export const isJson = (token) => {
  try {
    JSON.parse(token);
  } catch (err) {
    return false;
  }
  return true;
};

export const dateDiffCount = (startDate, endDate) => {
  // const date1 = startDate;
  // const date2 = endDate;
  const dateDiff = endDate.diff(startDate, "day") + 1;
  // const diffTime = Math.abs(date1 - date2);
  // let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  // const hours = Math.floor(diffTime / (1000 * 3600)) % 24;
  // const minutes = Math.floor(diffTime / 60) % 60;
  // if (diffDays > 0) {
  //   if (hours > 0) {
  //     ++diffDays;
  //   } else if (minutes > 0) {
  //     ++diffDays;
  //   }else{
  //     ++diffDays
  //   }
  // } else {
  //   diffDays = 1;
  // }
  // return new Date(date1?._d)?.toDateString() ===
  //   new Date(date2?._d)?.toDateString()
  //   ? 1
  //   : diffDays;
  return dateDiff;
};
export const debounce = (fn, delay) => {
  let timer = null;
  return function (...arg) {
    const context = this;
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, arg);
    }, delay);
  };
};
export const redirectAnotherTab = (link, self = false) => {
  const tempLink = link?.split("/");
  if (tempLink?.[2] !== reUrl) {
    if (isiOSApp()) {
      // console.log("is ios");
      window.openLinkInBrowser && window.openLinkInBrowser(link);
    } else if (isAndroidApp()) {
      // console.log("is Android");
      window.Android &&
        window.Android.openLinkInBrowser &&
        window.Android.openLinkInBrowser(link);
    } else {
      if (self == true) {
        window.open(link, "_self");
      } else {
        window.open(link, "_blank");
      }
    }
  } else {
    window.open(link, "_self");
  }
};
export const scrollTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
export const motorcycleMileage = [
  { displayName: "0 - 5,000", value: "Below 5,000" },
  { displayName: "5,000 - 10,000", value: "5,000 - 10,000" },
  { displayName: "10,000 - 20,000", value: "10,000 - 20,000" },
  { displayName: "20,000 - 30,000", value: "20,000 - 30,000" },
  { displayName: "30,000 - 50,000", value: "30,000 - 50,000" },
  { displayName: "Above 50,000", value: "Above 50,000" },
];
export const motorcycleModal = [
  "Classic 350",
  "Classic 500",
  "Bullet 350",
  "Bullet 500",
  "Bullet Trials 350",
  "Bullet Trials 500",
  "Thunderbird 350",
  "Thunderbird 500",
  "ThunderbirdX 350",
  "ThunderbirdX 500",
  "Meteor 350",
  "Interceptor 650",
  "Continental GT 650",
  "Continental GT 535",
];

export const nameValidation = /^([a-zA-Z]+\s)*[a-zA-Z]+$/;
export const emailValidation = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i;
export const inputValidation = /^[a-zA-Z0-9 ]+$/i;
export const mobileNumericValidation = /[1-9][0-9]{7,14}/;
export const pinCodeNumericValidation = /[0-9]/; ///validation for only numeric value
export const mobileOnlyKeyValidation = /^\s*\s*$|[^0-9]/gi; //validation to only accept numeric key
export const gstNumberValidation =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i;
export const acceptOnlyDocuments =
  "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf";
export const acceptDocumentUploadValidation =
  "application/pdf,image/x-png,image/jpeg";
export const accpetOnlyImage = "image/x-png,image/jpeg,image/jpg";
export const acceptOnlyVideo = "video/mp4,video/x-m4v,video/*";
export const onlyImageValidation = /(\.jpg|\.jpeg|\.png)$/i;
export const doucmentValidation = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
export const excelCSVValidation = /(\.xlsx|\.xls|\.csv)$/i;
export const latitudeValidation =
  /^(-?([1-8]?[0-9])(\.[0-9]{1,20})?|90(\.0{1,20})?)$/;
export const longitudeValidation =
  /^(-?((1?[0-7]?|[0-9]?)[0-9])(\.[0-9]{1,20})?|180(\.0{1,20})?)$/;
export const otpValidation = /[A-Z0-9]{10}/;
export const registrationValidation = /[A-Za-z0-9]/;
export const websiteValidation =
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

export const facebookValidation =
  /(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/;
export const twitterValidation =
  /(?:(?:http|https):\/\/)?(?:www.)?twitter.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/;
export const instaValidation =
  /(?:(?:http|https):\/\/)?(?:www.)?instagram.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/;
export const googleMapValidation =
  /^https:\/\/(maps\.app\.goo\.gl\/[^\s/]+|(www\.)?(google\.[a-z]{2,3}\/maps\/|google\.[a-z]{2,3}\.[a-z]{2,3}\/maps\/|goo\.gl\/maps\/))[^\s]*$/;

export const defaultProfileImage =
  assetPath + "/main/assets/img/dummy/profile_image.jpg";
export const inputTextValidation = /^\s*\s*$|[^a-zA-Z ]/gi;
export const characterValidation = /^[A-Za-z]+$/;

export const notShowCartUrl = ["", "Faq", "emptycart"];

export const pageName = {
  rental: "Rentals",
  list_motorcycles: "Rentals",
  booking: "Booking",
  bookingsuccess: "Booking",
  bookingdetails: "Profile",
  "tour-customer": "Tour",
  rentalpatner: "Our Rental Partners",
  rentalpatnerdetail: "Rentrip",
};

export function redirectExternalLink(url, domain) {
  // console.log(`url`, url);
  if (url.startsWith("/content/royal-enfield")) {
    var final_path = domain;
    var split_url = url.split("/");
    for (var i = 0; i < split_url.length; i++) {
      if (i > 2) {
        final_path = final_path + split_url[i] + "/";
      }
    }
    window.location.href = final_path;
    // window.open(final_path, "_blank");
  } else {
    window.location.href = url;
    // window.open(url, "_blank");
  }
}

export function redirectExternalLinkForFooter(url, domain) {
  // console.log(`url`, url);
  if (url.startsWith("/content/royal-enfield")) {
    var final_path = domain;
    var split_url = url.split("/");
    for (var i = 0; i < split_url.length; i++) {
      if (i > 2) {
        final_path = final_path + split_url[i] + "/";
      }
    }
    window.open(final_path, "_self");
  } else {
    window.open(url, "_self");
  }
}

export const removeLastWord = (str) => {
  var lastIndex = str?.lastIndexOf(" ");
  str = str?.substring(0, lastIndex);
  return str;
};

export const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};

export function toPascalCase(str) {
  return str.replace(/(\w)(\w*)/g, function (_, first, rest) {
    return first.toUpperCase() + rest.toLowerCase();
  });
}

export const maxContractFileSize = 15000000;
export const maxFileSizeContract = 10000000;
export const maxFileSize = 2000000;
export const maxFileSizeResourceMb = 10;
export const maxImageSizeResourceMb = 2;
export const maxPdfFileSize = 5000000;
export const maxFileSizeSignature = 10000000;
export const maxTourFileSize = 1000000;
export const maxTourvideoSize = 10000000;

export const motorcycleImageCropObj = {
  unit: "px",
  width: 400,
  height: 400,
  x: 0,
  y: 0,
};
export const motorcycleOnboardingImageCropObj = {
  unit: "px",
  width: 370,
  height: 170,
  x: 0,
  y: 0,
};
export const profileImageCropObj = { unit: "px", width: 400, height: 400 };
export const fleetMotorcycleImageCropObj = {
  unit: "px",
  width: 400,
  height: 400,
};
export const bannerImageCropObj = { unit: "px", width: 1000, height: 270 };
export const bannerImageCropObjMin = { unit: "px", width: 1350, height: 390 };

export const bannerImageCropObject = { unit: "px", width: 1366, height: 400 };
export const bannerImageCropObjMax = { unit: "px", width: 1380, height: 410 };
export const newMotorcycleImageCropObj = { width: 730, height: 324 };
export const TourOverviewImageCropObj = {
  unit: "px",
  width: 1100,
  height: 450,
};
export const newMotorcycleImageCropObjAspectRatio = 2.2 / 1;
export const highlightsImageCropObjecAspectRatio = 3 / 1;
export const newbannerImageCropObj = { width: 1366, height: 270 };
export const newbannerImageCropObjAspectRatio = 5 / 1;
export const newprofileImageCropObj = { width: 300, height: 300 };
export const logoImageCropObj = { unit: "px", width: 200, height: 200 };
export const highlightsImageCropObj = {
  unit: "px",
  width: 1600,
  height: 700,
};
export const daywiseImageCropObj = 1 / 1;
export const operatorBannerImage = 5 / 3;
export const operatorBannerImageAspectRatio = 4 / 1;
export function notinArray(item, temp) {
  var i;
  for (i = 0; i < temp.length; i++) {
    if (temp[i] === item) {
      return true;
    }
  }
  return false;
}

export const resendSeconds = 30000;
export const resendStr = 30;

export function getFilterSelected(model, price, operator, km_range, location) {
  var filterSelected = "";
  if (model !== "") {
    filterSelected += "Royal Enfield Models|";
  }
  if (location !== "") {
    filterSelected += "Location|";
  }
  if (price !== "") {
    filterSelected += "Price|";
  }
  if (operator !== "") {
    filterSelected += "Partners|";
  }
  if (km_range !== "") {
    filterSelected += "Km Range|";
  }

  return filterSelected.slice(0, -1);
}

export function proceedToPayAddRider(data, days) {
  var modelName = "";
  var location = "";
  var priceRange = "";
  var operatorName = "";
  var kmRange = "";
  data.forEach((each) => {
    modelName += each?.name + "|";
    location += each?.motorcycle_location + "|";
    priceRange += each?.priceArray?.[0]?.value + "|";
    operatorName += each?.operatorName + "|";
    kmRange += each?.approxkmsrun + "|";
  });

  const gaData = {
    event: eventName,
    eventCategory: "Wanderlust Rental",
    eventAction: "Add Riders",
    modelName: modelName.slice(0, -1),
    location: location.slice(0, -1),
    priceRange: priceRange.slice(0, -1),
    operatorName: operatorName.slice(0, -1),
    kmRange: kmRange.slice(0, -1),
    days: days,
    motorcycleCount: data?.length,
  };
  googleAnalyticsData(gaData);
}

export function getHeaderLink(url, domain) {
  if (url?.startsWith("/content/royal-enfield")) {
    var final_path = domain;
    var split_url = url?.split("/");
    for (var i = 0; i < split_url.length; i++) {
      if (i > 2) {
        final_path = final_path + split_url[i] + "/";
      }
    }
    return final_path;
  } else {
    return url;
  }
}

export const motorcyclesToShow = 8;

export function getSplittedUrl() {
  let wurl = window.location.href;
  let url = new URL(wurl);
  return url.pathname?.split("/");
}

export const currencySymbol = {
  USD: "$",
  INR: "₹",
  GBP: "£",
  EUR: "€",
};

export function setRatingValues(value) {
  const rating = parseFloat(value ? value : 0)
    .toFixed(1)
    .split(".");
  if (rating[1] == 0) {
    return rating[0];
  } else {
    return parseFloat(value ? value : 0).toFixed(1);
  }
}

export function isTourCustomer() {
  let wurl = window.location.href;
  let url = new URL(wurl);
  let finalPath = url.pathname?.split("/");
  return finalPath?.[1] == tourCustomerRoute;
}

export const getAdminToken = async (callback) => {
  // dispatch(getAdminTokenRequest());
  try {
    let { data } = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}${getAdminTokenApi}`
    );
    // .then((res) => {
    console.log("ressstt", data);
    if (data?.code === "200") {
      // dispatch(getAdminTokenSuccess(res?.data));
      callback && callback(data?.data);
      return data?.data;
    } else {
      // dispatch(getAdminTokenError(res));
      return "";
    }
    // })
    // .catch((err) => {
    //   console.log("bookingList error", err);
    //   // dispatch(getAdminTokenError(err));
    //   return "";
    // });
    // console.log("token", token);
  } catch (error) {
    // dispatch(getAdminTokenError("Something went wrong"));
    return "";
  }
};

export const callingCodePlusPrefixHandler = (callingcode) => {
  if (callingcode) {
    if (callingcode?.startsWith("+")) return callingcode;
    else return `+${callingcode}`;
  }
  return "";
};

export const currencysymbolHandler = (currencyList, selectedCurrency) => {
  let symbol = currencyList?.filter((currency) => {
    if (currency?.currency === selectedCurrency) {
      return currency.currency_symbol;
    }
  });
  if (symbol?.length) {
    return symbol?.[0]?.currency_symbol;
  }
  return "";
};

export const rsSymbolHandler = (symbol) => {
  if (symbol === "Below ₹ 40 L") {
    return "";
  } else {
    return "₹";
  }
};

export const isMobileView = () => {
  return window.matchMedia("(max-width: 567px)").matches;
};
export const deepCloneObject = (obj) => {
  const deepClone = JSON.parse(JSON.stringify(obj));
  return deepClone;
};

export const updateStateObject = (
  oldState,
  newState,
  hasNestedState = false
) => {
  if (!hasNestedState) {
    const cloneState = deepCloneObject(oldState);
    return { ...cloneState, ...newState };
  }

  return { ...oldState, ...newState };
};

export const useSearchFilter = (search, filterBody, filterData, dispatch) => {
  useEffect(() => {
    let timer;
    if (search) {
      timer = setTimeout(() => {
        dispatch(filterData(filterBody));
      }, 500);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [search]);
};

export const setFileDimensions = (file, height, width, imageName, callback) => {
  const img = new Image();
  img.src = URL.createObjectURL(file);
  img.onload = () => {
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);
    canvas.toBlob((newBlob) => {
      const reader = new FileReader();
      reader.readAsDataURL(newBlob);
      reader.onloadend = () => {
        const file = new File([newBlob], imageName, {
          type: newBlob.type,
        });
        console.log("doneee111", file);
        // return file;
        callback && callback(file);
      };
    });
  };
};

export const rsaAvailability = [
  "No RSA available.",
  "Operator will provide RSA",
  "Royal Enfield RSA Purchased",
];

export const getStatusSpan = (status) => {
  switch (status) {
    case "":
    case "OPEN":
      return <span className="status closed">Open</span>;
    case "IN-PROGRESS":
      return <span className="status in-progress">In-Progress</span>;
    case "CLOSED":
      return <span className="status open">Closed</span>;
    default:
      return "N/A";
  }
};
